// extracted by mini-css-extract-plugin
export default {"layoutElem":"layout_layoutElem__1W3Vl","footerClass":"layout_footerClass__OyLhM"};